import BitSvg from "@/../../hypetrain/static/img/bit.svg";

import { EmbedSvg } from "@/components/helpers/ui/EmbedSvg";

interface BitIconProps {
  height?: number;
  width?: number;
}

export function BitIcon({ height = 24, width = 24 }: BitIconProps) {
  return <EmbedSvg src={BitSvg} height={height} width={width} lazy={false} />;
}
